import { unref, computed } from 'vue'
import { useAttributeFormatter } from 'ifield-core-components'

/**
 * ユーザーリスト表示項目(ユーザー属性)の利用
 * @param {MaybeRef.<string>} attributeType 属性タイプ
 * @param {MaybeRef.<string>} attirbuteName 属性名
 * @param {MaybeRef.<string>} value 属性値
 */
export function useUserStatusAdditionalItemUserAttribute({
  attributeType,
  attributeName,
  value,
}) {
  const { attributeFormatter } = useAttributeFormatter()

  /**
   * ユーザー属性値表示テキスト
   * @type {ComputedRef.<string>}
   */
  const valueText = computed(() => {
    const v = unref(value)
    const type = unref(attributeType)
    if (v == null) {
      return '-'
    } else if (type in attributeFormatter) {
      return attributeFormatter[type](v)
    } else {
      return v
    }
  })

  /**
   * ユーザー属性表示テキスト
   * @type {ComputedRef.<string>}
   */
  const text = computed(
    () => `${valueText.value} (${unref(attributeName) || ''})`
  )

  return { text, valueText }
}
